import axios, { AxiosInstance } from "axios";

// Function to get credentials based on user type from localStorage
const getCredentials = () => {
  const userType = localStorage.getItem('userType');
  
  if (userType === 'user' || !userType) {
    return btoa(`${process.env.REACT_APP_USER_NAME}:${process.env.REACT_APP_USER_PASS}`);
  }
  
  return btoa(`${process.env.REACT_APP_PAZIRANDE_NAME}:${process.env.REACT_APP_PAZIRANDE_PASS}`);
  // Default to user credentials
};

/**
 * parseJwt
 *
 * تابعی برای پارس کردن JWT و استخراج payload آن.
 * در صورت وجود خطا (توکن نامعتبر یا فرمت اشتباه)، `null` برمی‌گرداند.
 *
 * @param token رشته JWT برای پارس شدن
 * @returns payload توکن یا null در صورت خطا
 */
export function parseJwt(token: string) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

/**
 * api
 *
 * نمونه‌ای از axios پیشرفته برای ارسال درخواست‌های HTTP به سرور با پشتیبانی از:
 * - احراز هویت اولیه با Basic Auth (بر اساس نوع کاربر انتخاب شده)
 * - مدیریت JWT از localStorage و بررسی زمان انقضا
 * - ریدایرکت خودکار به صفحه ورود در صورت منقضی شدن توکن یا پاسخ 401
 * - تنظیم هدرهای پیش‌فرض JSON
 *
 * Interceptors:
 * - **Request Interceptor**: بررسی توکن JWT و جایگزینی هدر Authorization با `Bearer <token>`
 * - **Response Interceptor**: مدیریت پاسخ‌های 401 و ریدایرکت به `/login`
 *
 * مثال استفاده:
 * ```ts
 * import api from "@/api/api";
 *
 * const response = await api.get("/user/profile");
 * ```
 */
const api: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor: مدیریت توکن JWT قبل از ارسال هر درخواست
api.interceptors.request.use(
  (config) => {
    // Set Basic Auth credentials based on user type from localStorage
    const credentials = getCredentials();
    config.headers.Authorization = `Basic ${credentials}`;
    
    const token = localStorage.getItem("token");

    if (token) {
      const parsedToken = parseJwt(token);

      if (parsedToken && parsedToken.exp) {
        const expiry = parsedToken.exp * 1000;
        const now = Date.now();

        if (now >= expiry) {
          // localStorage.removeItem("token");
          // window.location.href = "/login";
          // return Promise.reject("Expired token");
        }
      }

      config.headers.Authorization = `${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: مدیریت پاسخ‌ها و خطاهای 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // localStorage.removeItem("token");
      // window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;